module.exports = __webpack_public_path__ + "fonts/c851667.eot";